import { createStandardAction } from 'typesafe-actions'

export const togglePoliticiansDisplay = createStandardAction(
  'toggle/politiciansDisplay'
)<void>()
